import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title?: string;
    description?: string;
    canonical?: string;
    ogType?: string;
    ogImage?: string;
    twitterHandle?: string;
}

const SEO: React.FC<SEOProps> = ({
    title,
    description,
    canonical,
    ogType = 'website',
    ogImage,
    twitterHandle = '@nexoverseas',
    structuredData
}) => {
    const siteTitle = "NexOverseas | Premium Education Advisory";
    const fullTitle = title ? `${title} | NexOverseas` : siteTitle;
    const defaultDescription = "NexOverseas is the all-in-one operating system for your global career. We provide expert guidance on admissions, visas, travel, and accommodation.";
    const metaDescription = description || defaultDescription;
    const url = "https://www.nexoverseas.co.uk";
    const fullCanonical = canonical ? `${url}${canonical}` : url;

    return (
        <Helmet>
            {/* Standard metadata tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={metaDescription} />
            <link rel="canonical" href={fullCanonical} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={ogType} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:url" content={fullCanonical} />
            {ogImage && <meta property="og:image" content={ogImage} />}

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={metaDescription} />
            {twitterHandle && <meta name="twitter:site" content={twitterHandle} />}
            {ogImage && <meta name="twitter:image" content={ogImage} />}

            {/* Structured Data */}
            {structuredData && (
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;
